module.exports = __webpack_public_path__ + "static/diagnosis-21b56b09d238863fa8660414db95d946.pdf";